import React, { useEffect } from "react";
import { Form, Input, Button, Spin, Select, Switch } from "antd";
import isEmpTy from "lodash/isEmpty";
import { ReactSVG } from "react-svg";
import { ENGINE_TYPE } from "../../../constants";

const CompanyForm = ({ form, isFetching, company, handleSubmit, handleCancel, statuses }) => {
  useEffect(() => {
    form.setFieldsValue({
      name: company?.name,
      status: company?.status,
      tokenEngine: company?.tokenEngine,
      googleDirectionsKey: company?.googleDirectionsKey,
      geocodeGoogleKey: company?.geocodeGoogleKey,
      snapToRoad: company?.snapToRoad,
      engineType: company?.engineType,
      pdpUrl: company?.pdpUrl || null,
      pdpAccessToken: company?.pdpAccessToken || null,
      vrpUrl: company?.vrpUrl || null,
      vrpAccessToken: company?.vrpAccessToken || null,
    });
  }, [company]);

  return (
    <Spin spinning={isFetching}>
      <div className="CompanyForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
          <div className="FormHeader">
            <div className="left">{company ? "Edit Company" : "New Company"}</div>
          </div>
          <div className="FormContent">
            <Form.Item label="Company Name" name="name" rules={[{ required: true, message: "Required" }]}>
              <Input size="large" placeholder="Company Name" />
            </Form.Item>
            {!isEmpTy(company) && (
              <Form.Item label="Status" name="status" rules={[{ required: true, message: "Required" }]}>
                <Select size="large" placeholder="What best describes your company?">
                  {Object.keys(statuses).map(k => (
                    <Select.Option key={statuses[k]["value"]} value={statuses[k]["value"]}>
                      <span style={{ color: statuses[k]["color"] }}>{statuses[k]["label"]}</span>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            <Form.Item label="Token Routing Engine" name="tokenEngine">
              <Input size="large" />
            </Form.Item>
            <Form.Item label="Geocode Google Key" name="geocodeGoogleKey">
              <Input size="large" />
            </Form.Item>
            <Form.Item label="Google Directions Key" name="googleDirectionsKey">
              <Input size="large" />
            </Form.Item>
            <Form.Item label="Snap To Road" name="snapToRoad" valuePropName="checked">
              <Switch />
            </Form.Item>
            <Form.Item label="Data Source" name="engineType">
              <Select size="large" placeholder="Select engine">
                {Object.keys(ENGINE_TYPE).map(k => (
                  <Select.Option key={k} value={k}>
                    {ENGINE_TYPE[k]}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label="PDP URL" name="pdpUrl">
              <Input size="large" />
            </Form.Item>

            <Form.Item label="PDP Access Token" name="pdpAccessToken">
              <Input size="large" />
            </Form.Item>

            <Form.Item label="VRP URL" name="vrpUrl">
              <Input size="large" />
            </Form.Item>

            <Form.Item label="VRP Access Token" name="vrpAccessToken">
              <Input size="large" />
            </Form.Item>
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <Button key="cancel" onClick={handleCancel}>
                Cancel
              </Button>
              <Button htmlType="submit" type="primary">
                {company ? "Update" : "Create"}
                <ReactSVG className="icon" src="/icons/submit.svg" />
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default CompanyForm;
